export const contentData = {
    spanish: {
        title: 'Evaluaciones',
        button: null,
        nodata: 'Sin Registro',
        header: [
            { id: 1, label: 'ID' },
            { id: 7, label: 'Periodo' },
            { id: 3, label: 'Usuario' },
            { id: 4, label: 'Estatus' },
            { id: 5, label: 'Puntaje' },
            
            { id: 8, label: 'Fecha de evaluación' },
            { id: 9, label: 'Documento' },
        ]
    }
}
